import React from "react";

// Menu DropdownToggle container
export const menuContainerStyle: React.CSSProperties = {
    marginLeft: "40px",
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "flex-start",
    alignItems: "center"
};

//module menu item (enabled)
export const moduleEnabledStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "0.4rem 1rem",
    color: "white",
    textDecoration: "none",
    width: "100%",
    cursor: "pointer",
    userSelect: "none",
};

//module menu item (disabled)
export const moduleDisabledStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "0.4rem 1rem",
    width: "100%",
    cursor: "not-allowed",
    background: "transparent",
    color: "var(--medium-gray)",
    userSelect: "none"
};
